import React from 'react';

import moment from 'moment';

import { Container, Day } from './styles';

const Week = () => {
  const weekdays = [...Array(7)].map((_, index) => moment().weekday(index).format('ddd').substr(0, 1));

  return (
    <Container>
      <Day>{weekdays[0]}</Day>
      <Day>{weekdays[1]}</Day>
      <Day>{weekdays[2]}</Day>
      <Day>{weekdays[3]}</Day>
      <Day>{weekdays[4]}</Day>
      <Day>{weekdays[5]}</Day>
      <Day>{weekdays[6]}</Day>
    </Container>
  );
};

export default Week;
